import client from './client';

export interface MediaAsset {
  id: string;
  filename: string;
  originalFilename?: string | null;
  contentType?: string | null;
  size?: number | null;
  url: string;
  uploadType: string;
  referenceId?: string | null;
  linked: boolean;
  uploadedBy?: string | null;
  createdAt: string;
}

export interface MediaPage {
  content: MediaAsset[];
  totalElements: number;
  totalPages: number;
  number: number;
  size: number;
}

export const mediaApi = {
  getAll: async (params?: {
    page?: number;
    size?: number;
    uploadType?: string;
    linked?: boolean;
    search?: string;
  }): Promise<MediaPage> => {
    const response = await client.get<MediaPage>('/admin/media', { params });
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await client.delete(`/admin/media/${id}`);
  },

  attach: async (data: {
    url: string;
    entityType: 'PRODUCT' | 'SUPPLY';
    entityId: string;
    displayName?: string;
    primary?: boolean;
  }): Promise<MediaAsset> => {
    const response = await client.post<MediaAsset>('/admin/media/attach', data);
    return response.data;
  },

  backfill: async (): Promise<number> => {
    const response = await client.post<number>('/admin/media/backfill');
    return response.data;
  },
};
